export default "__VITE_ASSET__500b705c__"